import _ from 'lodash';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, Directive, ElementRef, HostListener, inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { debounceTime, filter, map, switchMap, tap } from 'rxjs/operators';
import { selectEventList } from 'app/event/features/event.selectors';
import { selectNotArchivedCampaignList } from 'app/campaign/features/campaign.selectors';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { Observable, of } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PendingService } from 'app/reports/services/pending.service';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { loadEventList } from 'app/event/features/event.actions';
import { loadPendingCampaignList } from 'app/campaign/features/campaign.actions';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { DialogService } from 'app/dialog/services/dialog.service';
import { MDBDropdownService } from 'app/core/services/mdb-dropdown.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DonorService } from 'app/core/services/donor.service';
import {EmailNameSpliterService} from 'app/core/services/email-name-spliter.service'
@Directive({selector: 'input[currency]'})
export class oldStyledCurrencyDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener(`keyup`)
  onKeyup(event) {
    const { nativeElement } = this.elementRef;
    window['formatCurrency'](window['$'](nativeElement))
    window['checkAmount'](nativeElement.id)
  }

  @HostListener(`blur`)
  onBlur(event) {
    const { nativeElement } = this.elementRef;
    window['formatCurrency'](window['$'](nativeElement))
    window['checkAmount'](nativeElement.id)
  }
}

@Component({
  selector: 'app-add-pending',
  templateUrl: './add-pending.component.html',
  styleUrls: ['./add-pending.component.scss']
})
export class AddPendingComponent implements OnInit, AfterViewInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  private dialog: any = null;

  public form: UntypedFormGroup = new UntypedFormGroup({
    event: new UntypedFormControl(null, []),
    eventType: new UntypedFormControl(null, []),
    email: new UntypedFormControl("", [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)]),
    name: new UntypedFormControl("", [Validators.required]),
    campaign: new UntypedFormControl(null, [Validators.required]),
    option: new UntypedFormControl(null, [Validators.required]),
    amount: new UntypedFormControl("$0.0"),
    quantity: new UntypedFormControl(0),
    additionalInfo: new UntypedFormControl(''),
    additionalInfoSelected: new UntypedFormControl(''),
    address: new UntypedFormControl(''),
    unitNum: new UntypedFormControl(''),
    phone: new UntypedFormControl('')
  });

  public donorData = null;
  public campaignType;

  public addressObject = null;

  public events$ 
  public campaigns$: any = this.store.pipe(
    select(selectNotArchivedCampaignList),
    map(list => {
      return _.filter(list, campaign => {
        switch(campaign.type) {
          case CAMPAIGN_TYPE.AUCTION:
          case CAMPAIGN_TYPE.DONATE:
          case CAMPAIGN_TYPE.LAST_HERO:
          case CAMPAIGN_TYPE.TICKETING:
          case CAMPAIGN_TYPE.HINDU_TEMPLE_PUJA:
          case CAMPAIGN_TYPE.MERCHANDISE:
          case CAMPAIGN_TYPE.PARTY_SIGNUP:
            return true;
        }
        return false;
      });
    })
  );
  public campaigns = [];
  public campaignSelected: boolean = false;
  public selectedCampaign: any | null = null;
  public options$: Observable<any[]>;
  public options = [];
  public amount$: Observable<any>;
  public quantity$: Observable<any>;
  public isQuantityAvailable = true;
  public avialibleQuantityNum = null;
  public enforceInventory = false;
  public quantityErrorText = null;

  public isMerchandiseCamp = false;
  public isPartySignupCamp = false;
  public selectedOption = null;

  public isAdditionalInfoSelectListShow = false;
  public additionalInfoSelectList = [];
  public additionalInfoSelectListHeader = '';  

  public isAddressRequired = false;
  public streetAddress = null;
  public unit = null;

  public additionalInfoRequired = false;
  public additionalInfoHeader = '';
  public detail = '';

  public isPhoneRequired = false;

  public selectedEventType: UntypedFormControl = new UntypedFormControl('-1');
  public isOptionSelected = false
  public isEventTypeSelected = false
  public showAdditionalInformation = false;

  public num = 0

  public isShowForm = false;
  public selectedQuantity = 0;
  private enteredQuantity = 0;

  public step = 1;

  public initialStateCampaignPresent = false;

  private allProfiles: any = null;
  public searchResult = [];

  constructor(
    public store: Store,
    public pendingService: PendingService,
    public sharedService: SharedService,
    public dialogService: DialogService,
    public dropdownService: MDBDropdownService,
    public ngZone: NgZone,
    public cdr: ChangeDetectorRef,
    private donorService: DonorService,
    private emailNameSpliter: EmailNameSpliterService
  ) { }

  ngOnInit(): void {
    if(this.sharedService.token) {
      this.store.dispatch({
        type: loadEventList.type,
        payload: this.sharedService.token
      });

      this.store.dispatch({
        type: loadPendingCampaignList.type,
        payload: this.sharedService.token
      });
    }

    this.dialog$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((dialog) => {
      this.dialog = dialog;
    });

  }
  
  ngAfterViewInit() {
    const { form } = this;

    this.setSearchSubscription('email', 0);
    this.setSearchSubscription('name', 1);

    this.options$ = form.get('campaign').valueChanges
    .pipe(
      tap(() => {
        this.campaignSelected = true;
      }),
      map(id => {
        form.get('option').setValue(null);
        form.get('amount').setValue("$0.0");
        form.get('quantity').setValue(0);
        this.isShowForm = false;

        let campaign = this.getSelectedCampaignById(id);
        const options = _.get(campaign, 'campaignTypeData.presetOptions', []);
        
        let result = options;
        this.campaignType = campaign.type;
        switch(campaign.type) {
          case CAMPAIGN_TYPE.AUCTION:
            result = _.map(options, presetOption => {
              const isSoldOut = presetOption.count - presetOption.soldCount < 1;
              return {
                ...presetOption,
                soldOut: isSoldOut
              }
            });
            break;
          case CAMPAIGN_TYPE.DONATE:
            result = [...result, { id: "false", name: "Custom Amount", selected: true }];
            break;
          case CAMPAIGN_TYPE.TICKETING:
            result = _.map(options, presetOption => {
              const data = window['orgMain'].isTicketCountAvailale(campaign.campaignTypeData, presetOption);
              return {
                ...presetOption,
                soldOut: !data.isQuantityAvailable
              }
          });
            break;
        }
        this.options = result;

        return result;
      }),
      
      takeUntilDestroyed(this.destroyRef)
    );

    this.options$.subscribe((list) => {
      const options: any = {}
      if(list.length > 10) {
        options.searchable = 'Search here...';
      }
      const html = this.dropdownService.getHTML('selectCampaignOptionList', this.options, options);

      const $ = window['$']
      $('#selectCampaignOptionList').materialSelect({destroy: true});
      $('#selectCampaignOptionList').off("change");
      document.getElementById('selectCampaignOptionListWrapper').innerHTML = html;
      $('#selectCampaignOptionList').materialSelect();
      $('#selectCampaignOptionList').change(() => {
        const value = $("#selectCampaignOptionList").val();
        form.get('option').setValue(value);
      });
    });

    form.get('option').valueChanges
    .pipe(
      takeUntilDestroyed(this.destroyRef)
    )
    .subscribe(
      (optionId => {
        const option = _.find(this.options, (option) => {
          return option.id === optionId;
        })
        const amount = _.get(option, 'amount', 0);
        this.form.get('amount').setValue(`$${amount}`);

        if(option){
          this.isOptionSelected = true;
          this.additionalInfoRequired  = false
          this.isAdditionalInfoSelectListShow = false;
          this.selectedOption = option

          const presetForm = option.shoppingForm || [];
          const filteredForm = presetForm.filter((field => field.status !== 1));

          this.isShowForm = filteredForm.length > 0 ? true: false;
          
          let selectedCampaignId = form.get('campaign').value
          let selectedCamp =  this.getSelectedCampaignById(selectedCampaignId);

          let additionalInfoRequired =  window['orgMain'].getAdditionalInfoRequired(selectedCamp, option);

          if(additionalInfoRequired){
            this.additionalInfoRequired = true
            this.additionalInfoHeader = option.additionalInfoDetail || selectedCamp.additionalInfoDetail || '';
            this.form.get('additionalInfo').setValue('');
            let detailWithTags = window['orgMain'].getAdditionalInfoDesc(selectedCamp,option);
            this.detail = detailWithTags.replace(/<p>(.*?)<\/p>/g, '$1');
          }

          this.additionalInfoSelectList = window['orgMain'].getAdditionalInfoSelect(selectedCamp, option);
          
          if(this.additionalInfoSelectList.length > 0){
            this.isAdditionalInfoSelectListShow = true;
            this.additionalInfoSelectListHeader =  window['orgMain'].getAdditionalInfoSelectDesc(selectedCamp, option);
            const options: any = {additionalInfoSelectList:true}
            const html = this.dropdownService.getHTML('selectAditionalInfoSelectList', this.additionalInfoSelectList, options);
            const $ = window['$'];
            $('#selectAditionalInfoSelectList').materialSelect({destroy: true});
            document.getElementById('selectAdditionalInfoSelectListWrapper').innerHTML = html;
            $('#selectAditionalInfoSelectList').materialSelect();
  
            $('#selectAditionalInfoSelectList').off("change");
            $('#selectAditionalInfoSelectList').change(() => {
              const value = $("#selectAditionalInfoSelectList").val();
              form.get('additionalInfoSelected').setValue(value);
            });
          }

          this.showAdditionalInformation = this.isAddressRequired || this.isPhoneRequired || this.additionalInfoRequired || this.isAdditionalInfoSelectListShow;
          if(this.showAdditionalInformation){
            window['$']('[data-toggle="tooltip"]').tooltip()
          }
        }

        this.addEventTypeSelect()
      })
    );

    this.campaigns$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((list) => {
      this.campaigns = this.dialog.initialState.campaigns || list;
      const campaignTypes = this.dialog.initialState.campaignTypes || [];
      this.selectedCampaign = this.dialog.initialState.selectedCampaign || null;
      this.initialStateCampaignPresent = this.selectedCampaign !== null;
      const options: any = {}

      if(campaignTypes.length > 0) {
        this.campaigns = this.campaigns.filter(campaign => {
          return campaignTypes.find(campaignType => campaignType == campaign.type) || false;
        });
      }
      if(this.campaigns.length > 10) {
        options.searchable = 'Search here...';
      }

      if(this.initialStateCampaignPresent){
        form.get('campaign').setValue(this.selectedCampaign.id);
        this.campaignSelectedHandle(this.selectedCampaign)
        this.campaignSelected = true;
      } else{
        const html = this.dropdownService.getHTML('selectCampaignList', this.campaigns, options);
        const $ = window['$'];
        $('#selectCampaignList').materialSelect({destroy: true});
        document.getElementById('selectCampaignListWrapper').innerHTML = html;
        $('#selectCampaignList').materialSelect();
  
        $('#selectCampaignList').off("change");
        $('#selectCampaignList').change(() => {
          const value = $("#selectCampaignList").val();
          form.get('campaign').setValue(value);
          this.selectedCampaign = this.getSelectedCampaignById(value);
  
          this.campaignSelectedHandle(this.selectedCampaign);
        });
      }
    })

    this.amount$ = form.valueChanges
    .pipe(
      map(data => {
        const campaignId = _.get(data, 'campaign', null);
        const campaign = this.getSelectedCampaignById(campaignId);
        const campaignType = _.get(campaign, 'type', null);

        const amount = form.get('amount');
        amount.clearValidators();

        switch(campaignType) {
          case CAMPAIGN_TYPE.AUCTION:
            amount.setValidators([Validators.required]);
            return true;
          case null:
            return false;
        }
        const id = _.get(data, 'option');
        if(_.isNull(id)) {
          return false;
        }
        if(_.isEqual(id, "false")) {
          const amount = form.get('amount');
          amount.setValidators([Validators.required]);
          return true;
        }
        return false;
      }),
      takeUntilDestroyed(this.destroyRef)
    );

    this.quantity$ = form.valueChanges
    .pipe(

      map(data => {
        const optionId =  _.get(data, 'option', null);
        const campaignId = _.get(data, 'campaign', null);
        const campaign = this.getSelectedCampaignById(campaignId);
        const presetOptions = _.get(campaign, 'campaignTypeData.presetOptions', []);

        const option = presetOptions.find(presetOption => {
          return presetOption.id === optionId;
        }) || null;

        const quantity = form.get('quantity');
        quantity.clearValidators();

        if(option) {
          const data = window['orgMain'].isTicketCountAvailale(campaign.campaignTypeData, option, quantity.value);
          this.enforceInventory = data.enforce;
          this.isQuantityAvailable = data.isQuantityAvailable;
          this.avialibleQuantityNum = data.avialibleQuantityNum;
        }

        const campaignType = _.get(campaign, 'type', null);

        switch(campaignType) {
          case CAMPAIGN_TYPE.TICKETING:
          case CAMPAIGN_TYPE.MERCHANDISE:
          case CAMPAIGN_TYPE.PARTY_SIGNUP:
            quantity.setValidators([Validators.required, Validators.min(1)]);
            return true;
        }

        return false;
      }),
      takeUntilDestroyed(this.destroyRef)
    );
  }

  private campaignSelectedHandle(selectedCampaign: any) {
    this.isAddressRequired = false;
    this.isPhoneRequired = false;
    this.isOptionSelected = false;
    this.showAdditionalInformation = false;
    this.isAdditionalInfoSelectListShow = false;
    this.additionalInfoRequired = false;
    this.form.get('additionalInfo').setValue('');
    this.form.get('address').setValue('');
    this.detail = '';

    this.isMerchandiseCamp = selectedCampaign.type == CAMPAIGN_TYPE.MERCHANDISE;
    this.isPartySignupCamp = selectedCampaign.type == CAMPAIGN_TYPE.PARTY_SIGNUP;
    let isAddressRequired = selectedCampaign.streetAddressRequired;
    let isPhoneRequired = selectedCampaign.phoneNumRequired;

    if (isAddressRequired) {
      this.isAddressRequired = true;
      this.streetAddress = this.donorData?.streetAddress || null;

      if (this.streetAddress) {
        this.form.get('address').setValue(this.streetAddress);
        this.form.get('unitNum').setValue(this.donorData.streetAddress.unitNum || '');
      } else {
        this.form.get('address').setValue('');
      }
      this.form.get('address').updateValueAndValidity({ emitEvent: false });
    }

    if (isPhoneRequired) {
      this.isPhoneRequired = true;
      if (this.donorData?.phone) {
        this.form.get('phone').setValue(this.donorData.phone);
      } else {
        this.form.get('phone').setValue('');
      };
    }

    this.additionalInfoSelectList = selectedCampaign.additionalInfoSelect;

    if (this.additionalInfoSelectList.length > 0) {
      this.isAdditionalInfoSelectListShow = true;
      this.additionalInfoSelectListHeader = selectedCampaign.additionalInfoSelectDesc || '';
      const options: any = { additionalInfoSelectList: true };
      const html = this.dropdownService.getHTML('selectAditionalInfoSelectList', this.additionalInfoSelectList, options);
      const $ = window['$'];
      $('#selectAditionalInfoSelectList').materialSelect({ destroy: true });
      document.getElementById('selectAdditionalInfoSelectListWrapper').innerHTML = html;
      $('#selectAditionalInfoSelectList').materialSelect();

      $('#selectAditionalInfoSelectList').off("change");
      $('#selectAditionalInfoSelectList').change(() => {
        const value = $("#selectAditionalInfoSelectList").val();
        this.form.get('additionalInfoSelected').setValue(value);
      });
    } else {
      this.isAdditionalInfoSelectListShow = false;
    }

    let additionalInfoRequired = !!selectedCampaign.additionalInfoDesc;

    if (additionalInfoRequired) {
      this.additionalInfoRequired = true;
      this.additionalInfoHeader = selectedCampaign.additionalInfoDetail || '';
      this.form.get('additionalInfo').setValue('');
      this.detail = selectedCampaign.additionalInfoDesc;
    } else {
      this.additionalInfoRequired = false;
    }

    this.showAdditionalInformation = this.isAddressRequired || this.isPhoneRequired || this.additionalInfoRequired || this.isAdditionalInfoSelectListShow;
    if (this.showAdditionalInformation) {
      window['$']('[data-toggle="tooltip"]').tooltip();
    }

    this.form.get('eventType').setValue(null);
    this.isEventTypeSelected = false;

    this.form.get('event').setValue(null);
  }

  ngOnDestroy(): void {
    this.dialogService.closeDialogSubject.next(null);
  }

  private setSearchSubscription(controlName: string, type: number){
    this.form.get(controlName).valueChanges
    .pipe(
      filter(value => _.isString(value)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      this.donorData = null;

      if (value.length > 2) {
        this.searchDonor(value, type);
      } else {
        this.searchResult = [];
      }
    });
  }

  searchDonor(value: string, searchType: number = 0 | 1) {
    this.donorService.search(value, searchType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((userProfiles) => {
        this.allProfiles = userProfiles;
        this.search(value);
    });
  }

  search(searchValue: string) {
    if (!this.allProfiles?.usersProfile) {
      this.searchResult = [];
      return;
    }

    const profileInfo = this.allProfiles.usersProfile.map(data => ({
      "data": data,
      "searchString": data.email + "/" + data.name
    }));

    const filteredResult = profileInfo.filter((item) => 
      item.searchString.toLowerCase().includes(searchValue.toLowerCase())
    );

    this.searchResult = filteredResult;
  }

  passOption(searchQuery: string | KeyboardEvent) {
    let searchString;
    if(searchQuery instanceof KeyboardEvent && searchQuery.target instanceof HTMLInputElement){
      searchString = searchQuery.target.value;
    } else {
      searchString = searchQuery as string;
    }

    const [email, name] = this.emailNameSpliter.getNameAndEmail(searchString)

    const selectedUser = this.allProfiles.usersProfile.find(user => 
      user.name === name && user.email === email
    );

    if (!selectedUser) {
      return;
    }

    this.donorData = selectedUser;

    this.form.patchValue({
      name: name,
      email: email
    }, { emitEvent: false });
    
    if (selectedUser?.streetAddress) {
      this.form.patchValue({
        address: selectedUser.streetAddress,
        unitNum: selectedUser.streetAddress?.unitNum || ''
      });
    } else {
      this.form.patchValue({
        address: '',
        unitNum: ''
      });
    }

    if (selectedUser?.phone) {
      this.form.patchValue({
        phone: selectedUser.phone
      });
    } else {
      this.form.patchValue({
        phone: ''
      });
    }
  }

  addEventTypeSelect(){
    if(this.num == 0){
      this.num = 1
      return
    }
    this.isOptionSelected = true
    if(this.isOptionSelected){
      let typeEvent = '<select [formControl]="selectedEventType" class="select-wrapper mdb-select mdb-select--paybee" id="selectEventTypeList"><option value="-1" disabled>Select Event Type</option><option value="0">In-person</option><option value="1">Virtual</option></select>'
      document.getElementById('selectEventTypeListWrapper').innerHTML=typeEvent;
      window['$']('#selectEventTypeList').materialSelect();
      window['$']('#selectEventTypeList').change(() => {
        const value = window['$']("#selectEventTypeList").val();
        this.form.get('eventType').setValue(value);

        if(value == 0 ){
          this.events$ = this.store.pipe(
            select(selectEventList),
            map(list => {
              const result = _.filter(list, event => {
                return (event.type == 1 ) ? false: true;
              });
              return result;
            })
          );
          this.isEventTypeSelected = true
          this.addEventSelect()
        }
        if(value == 1 ){
          this.events$ = this.store.pipe(
            select(selectEventList),
            map(list => {
              const result = _.filter(list, event => {
                return _.isEqual(event.type, 0 ) ? false: true;
              });
              return result;
            })
          );
          this.isEventTypeSelected = true
          this.addEventSelect()
        }

      })
    }

  }

  getFilteredEventList(events) {
    let list = _.filter(events, event => {
      switch(event.type) {
        case 0:
          return event.inPersonEventInfo.status === 0;
        case 1:
          return event.virtualEventInfo.status === 0;
        case 2:
          return event.hybridEventInfo.status === 0;
      }
      return false;
    }) || [];
    list = _.filter(list, event => {
      switch(event.type) {
        case 0:
          return event.inPersonEventInfo.isHybrid === false;
        case 1:
          return event.virtualEventInfo.isHybrid === false;
      }
      return event;
    });
    return _.sortBy(list, [function(event) { return -event.updated; }]);
  }

  onClickGoToForm(){
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this.cdr.markForCheck();
      return false;
    }

    this.step = 2;

    window['$']('.step-1').hide();
    window['$']('.step-2').show();
    this.createForm();
  }

  onBackClick(){
    this.step = 1;

    window['$']('.step-1').show();
    window['$']('.step-2').hide();
  }

  createForm(){
    let self = this;
    this.enteredQuantity = this.form.get('quantity').value;
    this.selectedQuantity = this.selectedOption.multiplier ? this.enteredQuantity * this.selectedOption.multiplier : this.enteredQuantity;
    const { textList, selectList, addressList, phoneList, finalHtml }  = window['orgMain'].getCampaignFormAccordionHTML(this.selectedOption,  this.form.get('quantity').value);
    window['$']('#merchandiseBlock').html(finalHtml);
    window['$'](`#contentAddToCartModal-1`).collapse('show');
    window['$']('#accordionExampleAddToCartModal').off('click');
    window['$']('#accordionExampleAddToCartModal').on('click', '[id^="header_buttonAddToCartModal-"]', function(event) {
      let id = event.currentTarget.id.split('-')[1];
      if(id > 1){
        window['orgMain'].validateForm(self.selectedOption, id - 1);
      }
  });

    selectList.forEach(element => {
          window['$'](`#${element}`).materialSelect({destroy: true});
          window['$'](`#${element}`).materialSelect();
    });

    phoneList.forEach(element=>{
          $(`#${element}`).removeClass("valid");
          $(`#${element}`).inputmask({
            mask: "+1 (999) 9999999",
            showMaskOnHover: false,
        });
    })

    addressList.forEach(element=>{
      window['orgMain'].loadStreetAddressAddToCart(element);
    })
  }

  addEventSelect(){

    this.events$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(events => {
      this.getFilteredEventList(events)
      let filteredEvents = this.getFilteredEventList(events)
      const options: any = {};
      if(events.length > 10) {
        options.searchable = 'Search here...';
      }
      const value = parseInt(this.form.get('eventType').value)

      switch(value) {
        case 0:
          options.getId = this.getEventValueInPerson.bind(this);
          options.getName = this.getEventNameInPerson.bind(this);
          break
        case 1:
          options.getId = this.getEventValue.bind(this);
          options.getName = this.getEventName.bind(this);
        break        
      }

      const html = this.dropdownService.getHTML('selectEventList', filteredEvents, options);
  
      const $ = window['$'];
      $('#selectEventList').materialSelect({destroy: true});
      document.getElementById('selectEventListWrapper').innerHTML = html;
      $('#selectEventList').materialSelect();

      $('#selectEventList').off("change");
      $('#selectEventList').change(() => {
        const value = $("#selectEventList").val();
        this.form.get('event').setValue(value);
      });
    })

  }

  getCampaignErrorMessage() {
    const { form } = this;
    const campaign = form.get('campaign');

    if(!campaign.touched) return '';

    if(campaign.hasError('required')) {
      return 'Please select Campaign';
    }

    return '';
  }

  getCampaignOptionErrorMessage() {
    const { form } = this;
    const option = form.get('option');

    if(!option.touched) return '';

    if(option.hasError('required')) {
      return 'Please select Campaign Option';
    }

    return '';
  }

  isAmountInvalid() {
    const amount = this.form.get('amount');
    const amountNum = parseInt(amount.value.slice(1))

    let validateAmount = true;

    switch (this.campaignType) {
      case CAMPAIGN_TYPE.TICKETING:
      case CAMPAIGN_TYPE.MERCHANDISE:
      case CAMPAIGN_TYPE.PARTY_SIGNUP:
      case CAMPAIGN_TYPE.HINDU_TEMPLE_PUJA:
        validateAmount = false;
    }

    if(!amountNum && validateAmount){
      this.form.get('amount').setErrors({'incorrect': true})
    } else {
      this.form.get('amount').setErrors(null)
    }

    return amount.invalid;
  }

  isQuantityValid() {
    if(this.campaignType !== CAMPAIGN_TYPE.TICKETING ||
      this.campaignType !== CAMPAIGN_TYPE.MERCHANDISE ||
      this.campaignType !== CAMPAIGN_TYPE.PARTY_SIGNUP
    ) {
      return true;
    }
    
    const quantity = this.form.get('quantity');
    return quantity.value > 0 && this.isQuantityAvailable;
  }

  getQuantityErrorMessage() {
    const { form } = this;
    const quantity = form.get('quantity');

    if(!quantity.touched ) return '';

    if(quantity.hasError('min') || !quantity.value ) {
      return 'Please provide Quantity greater than 1';
    }

    if(this.isQuantityAvailable){
      this.form.get('quantity').setErrors(null)
    } else {
      this.form.get('quantity').setErrors({'incorrect': true})
      const isAre = this.avialibleQuantityNum > 1 ? 'are' : 'is';
      return `Only ${this.avialibleQuantityNum} ${isAre} available.`
    }

    return ;
  }

  getEventValue(event) {
    switch(event.type) {
      case 1:
        return event.virtualEventInfo.id;
      case 2:
        return event.hybridEventInfo.virtualEvent.id;
    }
  }

  getEventName(event) {
    switch(event.type) {
      case 1:
        return event.virtualEventInfo.name;
      case 2:
        return event.hybridEventInfo.virtualEvent.name;
    }
  }

  getEventValueInPerson(event) {
    switch(event.type) {
      case 2:
        return event.hybridEventInfo.inPersonEvent.id;
      case 0:
          return event.inPersonEventInfo.id;
          
        
    }
  }

  getEventNameInPerson(event) {
    switch(event.type) {
      case 2:
        return event.hybridEventInfo.inPersonEvent.name;
      case 0:
          return event.inPersonEventInfo.name;
    }
  }

  getSelectedCampaignById(id){
    if(this.initialStateCampaignPresent){
      return this.selectedCampaign;
    }

    const campaign = _.find(this.campaigns, (campaign) => {
      return campaign.id === id;
    });
    return campaign;
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);
    
    if(value) {
      const { initialState: { action, callback } } = dialog;

      if(action) {
        this.store.dispatch(action);
      }
      const callbackData = this.getCallbackData();
      callback(callbackData);
    }
  }

  onConfirm(dialog, value) {
    this.isAmountInvalid()

    if(!this.isQuantityValid()) {
      this.form.markAllAsTouched();
      this.cdr.markForCheck();
      return false;
    }

    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this.cdr.markForCheck();
      return false;
    }

    if(this.campaignType == CAMPAIGN_TYPE.MERCHANDISE ||
      this.campaignType == CAMPAIGN_TYPE.PARTY_SIGNUP
    ) {
      const isValid = window['orgMain'].validateForm(this.selectedOption, this.enteredQuantity);
      if(isValid){
        this.close(dialog, value);
      } else {
        return false;
      }
      return
    }

    this.close(dialog, value);
  }

  getCallbackData() {
    const { form } = this;
    const event = form.get('event').value;
    const email = form.get('email').value;
    const name = form.get('name').value;
    const campaignId = form.get('campaign').value;
    const optionId = form.get('option').value;
    const amount = window['utils'].convertCurrencyToFloat(form.get('amount').value) || 0;
    const quantity = form.get('quantity').value;
    const merchandiseForm =  window['orgMain'].getFormParams(this.selectedOption, this.selectedQuantity);

    const campaign = this.getSelectedCampaignById(campaignId);

    let result: any = {
      from: _.isObject(this.donorData) ? {id: this.donorData.id} : { email, name },
      campaignIntId: campaign.intid,
      optionId: _.isEqual(optionId, "false") ? "": optionId,
    }
    result.formData = merchandiseForm;

    if(quantity > 0) {
      _.set(result, 'quantity', quantity);
      _.set(result, 'amount', amount * quantity);
    } else {
      _.set(result, 'amount', amount);
    }
    if(this.additionalInfoSelectList.length > 0){
      const additionalInfoSelected = form.get('additionalInfoSelected').value
      _.set(result, 'additionalInfoSelected', additionalInfoSelected);
    }

    if(this.additionalInfoRequired){
      const additionalInfo = form.get('additionalInfo').value
      _.set(result, 'additionalInfo', additionalInfo);
    }

    const streetAddress = this.form.get('address').value;
    let unitNum = form.get('unitNum').value;

    if(this.isAddressRequired && typeof streetAddress !== "string"){
      streetAddress.unitNum = unitNum;
      _.set(result, 'streetAddress', streetAddress);
    }

    const phone = this.form.get('phone').value;
    if(this.isPhoneRequired && phone !== ''){
      _.set(result, 'phone', phone);
    }

    if(_.isString(event)) {
      if(this.form.get('eventType').value == 0){
        result.eventId=event
      }
      if(this.form.get('eventType').value == 1){
        result.vEventId = event;
      }
    }

    return result;
  }
}
